module.exports = __webpack_public_path__ + "static/media/eu-china-sq.5458e0e7.jpg";